import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Page, ScanAsset, StepFinishScreen, Stepper, StepViewReport } from 'ui';
import { useLocale } from 'hooks/useLocale/useLocale';
import { ApproveAssetOwnerForm } from '../../ui/approveAssetOwnerForm/ApproveAssetOwnerForm';

import { ApproveAssetOwnerProps } from './ApproveAssetOwner.types';

export const ApproveAssetOwner = ({ onSubmit, isLoading }: ApproveAssetOwnerProps) => {
  const { formatMessage } = useLocale();
  const { setValue, watch } = useFormContext();
  const assetId = watch('id');

  const handleCodeRead = ({ goToNextStep, field }: { goToNextStep: VoidFunction; field: string }) => (data: string) => {
    setValue(field, data);
    goToNextStep();
  };

  return (
    <Page title={formatMessage({ id: 'install_battery.page_title' })}>
      <Stepper
        steps={[
          {
            label: formatMessage({ id: 'approve_asset_owner.steps.scan_user' }),
            content: (goToNextStep, goToPreviousStep) => (
              <ScanAsset
                handleRead={handleCodeRead({ goToNextStep, field: 'ownerAddress' })}
                goToPreviousStep={goToPreviousStep}
                goToNextStep={goToNextStep}
                delayNextScan
                skipInfo
              />
            ),
          },
          {
            label: formatMessage({ id: 'approve_asset_owner.steps.enter_details' }),
            content: (goToNextStep, goToPreviousStep) => (
              <ApproveAssetOwnerForm
                goToPreviousStep={goToPreviousStep}
                goToNextStep={goToNextStep}
                onSubmit={onSubmit}
              />
            ),
          },
          {
            label: formatMessage({ id: 'approve_asset_owner.steps.view_report' }),
            content: goToNextStep => (
              <StepViewReport
                goToNextStep={goToNextStep}
                isLoading={isLoading}
                text={formatMessage({ id: 'approve_asset_owner.processing' })}
              />
            ),
          },
        ]}
        finishStep={<StepFinishScreen id={assetId} skipDetails showAttachmentMessage={false} />}
      />
    </Page>
  );
};
